<template>
  <div class="container main-content article-content main-content--profile-ideas">
    <div class="section--ideas-grid">
      <IdeasGrid></IdeasGrid>
    </div>
  </div>
</template>

<script>
import IdeasGrid from "@/components/ideas/IdeasGrid";
export default {
  name: "ProfileIdeas",
  components: {IdeasGrid},
}
</script>

<style scoped>

</style>
